import React, { useMemo } from "react";
import { useInfiniteQuery, useQuery } from "react-query";
import {
  Copywriterssubmissionsmutation,
  totalvideoListCopywritersDashboard,
} from "../../../../api/functions/copywritersDashboard.api";
import {
  Backdrop,
  Box,
  Button,
  Dialog,
  Snackbar,
  Tab,
  Tabs,
} from "@mui/material";
import SeeAllButton from "../../../../ui/Icons/SeeAllButton";
import { useNavigate } from "react-router";
import styles from "../../../../styles/pages/user/copywriter-dashboard.module.scss";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  concatHostAndImagePath,
  getUtcDate,
  getUtcTime,
} from "../../../../lib/functions/utils.lib";
import { useInView } from "react-intersection-observer";
export default function UrgentTitiling() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  /***************feedbackModal****************/

  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickClose = () => {
    setOpen(false);
  };
  const handleClose = (value) => {
    setOpen(false);
  };

  /****************feedbackModal***************/

  const { data, fetchNextPage, hasNextPage, refetch, isLoading } =
    useInfiniteQuery({
      queryKey: [
        "totalvideoListCopywritersDashboard",
        // search, status1, date
      ],
      queryFn: ({ pageParam = 1 }) => {
        return totalvideoListCopywritersDashboard(pageParam);
      },
      keepPreviousData: true,
      enabled: true,

      getNextPageParam: (lastPage, allPages) => {
        if (
          allPages[allPages.length - 1 || 0].current_page <
          allPages[0]?.last_page
        ) {
          // console.warn(allPages[0].current_page + 1, "sdadasdas");
          // Assuming lastPage.length represents the number of items on the current page
          // You may need to adjust this logic based on your API response structure
          return allPages[allPages.length - 1 || 0].current_page + 1;
        } else {
          return undefined;
        }
      },
    });

  /* The above code is using the `useMemo` hook in React to process some data. */
  const processed_data = useMemo(() => {
    var dat = { data: [] };
    data?.pages?.forEach((item) => {
      dat = { ...item, data: [...dat.data, ...item?.data] };
    });
    return dat;
  }, [data]);

  const navigate = useNavigate();

  const sendData = (event) => {
    navigate(`/copywriter-dashboard/pending-titling-page?urgent_request=1`);
  };

  // const { mutate: mutating } = useMutation(getcopywritersdashboardSubmission);

  // useEffect(() => {
  //   const managerId = {
  //     copyright_id: props.selectedId,
  //     from: date?.startDate,
  //     to: date?.endDate,
  //   };
  //   mutating(managerId, {
  //     onSuccess: (data) => {
  //       // console.warn(data, "managerId")
  //       setManagerCardSubmissionData(data);
  //     },
  //   });
  // }, [date]);

  const { data: submissionList } = useQuery(
    ["VIDEOList"],

    async () => {
      return Copywriterssubmissionsmutation({
        // pending_titling: 1,
        // page: page,
      });
    }
  );

  const { ref, inView } = useInView({
    threshold: 0,
  });

  return (
    <Box className={styles.titlingListItem}>
      {processed_data?.data?.length > 0 ? (
        <Box
          className={`${styles.titlingListBox} ${styles.titlingListBoxActive}`}
        >
          <Box className={styles.titlingListBoxHeader}>
            {/* <UserCommonDropDown
            headingText="Urgent Titling Requests"
            totalData={processed_data?.total}
            empty={() => {}}
          /> */}
            <h4>
              Urgent Titling Requests <span>{processed_data?.total}</span>
            </h4>
            <Button endIcon={<SeeAllButton />} onClick={sendData}>
              See All
            </Button>
          </Box>
          <Box className={styles.titlingListBoxBody}>
            <InfiniteScroll
              className={styles.infiniteScroll}
              dataLength={
                // !!data &&
                // !!data.pages &&
                // data.pages.length > 0 &&
                processed_data?.data?.length
              }
              next={fetchNextPage}
              height={`calc(100vh - 390px)`}
              hasMore={hasNextPage}
              loader={<h4>Loading...</h4>}
            >
              {/* listingLoop */}
              {processed_data.data?.map((item, index) => {
                return (
                  <Box
                    className={styles.titlingListBoxItemMain}
                    key={index}
                    // onClick={handleClickOpen}
                  >
                    <Box className={styles.titlingListBoxItem}>
                      <Box className={styles.titlingListBoxItemImg}>
                        <figure>
                          <img
                            // src={item.image}
                            src={concatHostAndImagePath(item?.thumbnail)}
                            alt=""
                            width={100}
                            height={62}
                          />
                        </figure>
                      </Box>

                      <Box className={styles.titlingListBoxItemTxt}>
                        <p>
                          VSID:
                          <span>
                            {item.vsid}
                            {/* {item.vsidSpan} */}
                          </span>
                        </p>
                        <p>
                          {/* urgent_request_at */}
                          Pending Since:
                          <span>
                            {getUtcDate(item?.video_extra.urgent_request_at)}
                            {getUtcTime(item?.video_extra.urgent_request_at)}
                            {/* {item.pendingSpan} */}
                          </span>
                        </p>
                        <p>
                          Alerted by:{" "}
                          <span>
                            {item?.video_extra.urgent_request_by}
                            {/* {item.alertSpan} */}
                          </span>
                          <span className={styles.agent}>{item.agent}</span>
                        </p>
                      </Box>
                    </Box>
                  </Box>
                );
              })}
              <div ref={ref} className="inview-block"></div>
            </InfiniteScroll>

            <Box className={styles.list_btn_area}>
              {!hasNextPage && inView && (
                <Button
                  className={styles.endList}

                  // onClick={() => setShowMore1(!showMore1)}
                >
                  {/* {showMore1 ? "Show less" : "End of list."} */}
                  End of list.
                </Button>
              )}
            </Box>
          </Box>
        </Box>
      ) : (
        <Box
          className={`${styles.titlingListBox} ${styles.titlingListBoxActive} ${styles.titlingListBoxNoItem}`}
        >
          <Box className={styles.titlingListBoxHeader}>
            <h4>Urgent Titling Requests</h4>
          </Box>
          <Box className={styles.titlingListBoxBody}>
            <p>You have no urgent titling requests at the moment.</p>
          </Box>
        </Box>
      )}

      {/* <Box className={styles.activeColleage}>
                                                        <p>Another colleague is currently working on this video.</p>
                                                    </Box> */}
      {/* <Box className={`${styles.titlingListBox} ${styles.titlingListBoxActive} ${styles.titlingListBoxNoItem}`}>
                                <Box className={styles.titlingListBoxHeader}>
                                    <h4>Urgent Titling Requests</h4>
                                </Box>
                                <Box className={styles.titlingListBoxBody}>
                                    <p>You have no urgent titling requests at the moment.</p>
                                </Box>
                            </Box> */}
    </Box>
  );
}
